import { DrawerObject } from '../../../../components/drawer/drawer.types';
import { FormBuilderComponent } from '../../../../components/form-builder/form-builder.component';
import { DynamicForm } from '../../../../components/form-builder/form-builder.types';
import { BankDetailsRepository } from '../../../../store/bank-details-state/bank-details-state.repository';

interface getBankDetailsUpdateDrawerObjectProps {
  store?: BankDetailsRepository;
  formObject?: DynamicForm;
  toggleVisibility?: () => void;
  action?: () => void;
}

export const getBankDetailsUpdateDrawerObject = ({
  store,
  formObject,
  toggleVisibility,
  action,
}: getBankDetailsUpdateDrawerObjectProps): DrawerObject => {
  return {
    title: 'settings.bankDetails.update.title',
    description: '',
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject: formObject,
      },
    },
    actions: [
      {
        label: 'settings.bankDetails.update.update',
        onClick: () => action?.(),
      },
      {
        label: 'settings.bankDetails.update.cancel',
        onClick: () => {
          toggleVisibility?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
